import { connect } from 'react-redux';

import {
  generateCustomPracticeExam,
  getCustomPracticeExamReferences,
  getWeeklyPracticeExams,
} from '../actions/practiceExamActions';
import {
  getCustomPracticeExamRef,
  getCustomPracticeExamReferencesLoading,
  getCustomPracticeExamStatus,
} from '../components/PracticeExam/PracticeExamSelectors';
import ChapterCustomExamPopUp from '../components/Study/PersonalizedStudy/ChapterCustomExamPopUp';
import { getUser } from '../components/User/userSelectors';

const mapStateToProps = (state) => ({
  user: getUser(state),
  customPracticeExamStatus: getCustomPracticeExamStatus(state),
  getCustomPracticeExamRef: getCustomPracticeExamRef(state),
  getCustomPracticeExamRefLoading:
    getCustomPracticeExamReferencesLoading(state),
});

const mapDispatchToProps = (dispatch) => ({
  checkCustomPracticeExamStatus: () => dispatch(getWeeklyPracticeExams(true)),
  loadCustomExamRefs: (rateId) =>
    dispatch(getCustomPracticeExamReferences(rateId)),
  generateCustomPE: (chapterIds) =>
    dispatch(generateCustomPracticeExam(chapterIds)),
});

const ChapterCustomExamPopUpContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ChapterCustomExamPopUp);

export default ChapterCustomExamPopUpContainer;
